import Config from "../Config";
import Requisicao from "./RequisicaoService";

class InstitucionalService {
    static async get(id) {
        return Requisicao.get('institucional/all/' + id);
    }
}

export default InstitucionalService;